<div class="main-toolbar" layoutColumn #navbarWrapper (resized)="onResize($event)">
    <div layoutRow class="top-bar mat-elevation-z2">
        <cas-side-menu-button></cas-side-menu-button>
        <div class="spacer toolbar-content">
            <cas-main-title [ngClass]="{'shrinked': isHidden}" class="spacer"></cas-main-title>
            <cas-search-bar
                *ngIf="!hasContextButtons && this.isDefaultSearchButtonVisible"
                class="toolbar-buttons"
                [ngClass]="{'spacer': isHidden}">
                <div *ngIf="isFavoriteVisible">
                    <button mat-icon-button
                            (click)="setFavorite()">
                        <mat-icon>{{ favoriteIcon() }}</mat-icon>
                    </button>
                </div>
            </cas-search-bar>
            <cas-context-buttons *ngIf="hasContextButtons" class="toolbar-buttons">
            </cas-context-buttons>
        </div>
    </div>
</div>
<cas-banner></cas-banner>
